import styled from "styled-components";
import { pxToRem } from "../../styles/utils";

export const PageContainer = styled.div`
  display: flex;
  height: calc(100% - ${pxToRem(24)});
  margin: ${pxToRem(12)};
`;

export const ContentWrapper = styled.div`
  flex: 1;
  margin-left: 0;
  background: white;
  border-radius: ${pxToRem(16)};
  box-shadow: 0px ${pxToRem(9)} ${pxToRem(14.5)} rgba(0, 0, 0, 0.06),
    0px 0px ${pxToRem(6)} rgba(31, 10, 53, 0.05);
  padding: ${pxToRem(32)} ${pxToRem(25)};
  box-sizing: border-box;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: ${pxToRem(32)};
`;

export const TitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(8)};
`;

export const Title = styled.h1`
  font-size: ${pxToRem(32)};
  font-weight: 700;
  color: rgb(31, 10, 53);
`;

export const Subtitle = styled.p`
  margin: 0;
  color: rgba(31, 10, 53, 0.7);
  font-size: ${pxToRem(16)};
`;

export const HeaderActions = styled.div`
  display: flex;
  gap: ${pxToRem(16)};
`;

export const BreadcrumbsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${pxToRem(8)};
  font-size: ${pxToRem(14)};
  color: rgba(31, 10, 53, 0.5);
`;

export const BreadcrumbSeparator = styled.span`
  color: rgba(31, 10, 53, 0.3);
`;

export const BreadcrumbCurrent = styled.span`
  color: rgba(31, 10, 53, 0.7);
`;

